import React, { useEffect, useState } from 'react';
import { ensureScriptLoaded } from '../services/providers/ModulesProvider';
import PropTypes from 'prop-types';
import dynamicFederation from './dynamicFederation';

const ExternalPageLoader = ({ moduleUrl, containerName, componentPath, props = {} }) => {
  const [Component, setComponent] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadComponent = async () => {
      try {
        await ensureScriptLoaded(moduleUrl);
        
        const module = await dynamicFederation(containerName, componentPath);
        const Component = module.default || module;
        setComponent(() => Component);
      } catch (error) {
        console.error('Error loading external component:', error);
        setError(error);
      }
    };

    loadComponent();
  }, [moduleUrl, containerName, componentPath]);

  if (error) {
    return <div>Error loading component: {error.message}</div>;
  }

  if (!Component) {
    return <div></div>;
  }

  return <Component {...props} />;
};

ExternalPageLoader.propTypes = {
  moduleUrl: PropTypes.string.isRequired,
  containerName: PropTypes.string.isRequired,
  componentPath: PropTypes.string.isRequired,
  props: PropTypes.object
};

export default ExternalPageLoader;
